<template>
    <div>
        <div class="training-Msgbox">
            <div class="training-title">
                <div
                    class="certifiBtn"
                    v-if="leariningMsg.isConfigCert== 1"
                    @click="checkCertificate('businessId',leariningid,'btn','train')"
                >
                    <img src="./../../../assets/images/learning/cer-icon.png" alt v-if="isClickCertificate" />
                    <img src="./../../../assets/images/learning/cer-icon-disabled.png" alt v-else />
                </div>
                <div
                    class="training-top-bg"
                    :style="
                        'background-image:url(\'' + leariningMsg.iconUrl + '\')'
                    "
                >></div>
                <div class="training-top-opctiy"></div>
                <div class="training-back" @click="back">
                    <svg-icon icon-class="arrow-icon" class-name="arrow-icon"></svg-icon>
                </div>
                <ul class="trainingUl">
                    <li>
                        <a>
                            <img :src="leariningMsg.iconUrl" alt />
                        </a>
                        <div class="right">
                            <div :class="courseCount ? '' : 'justexam'">
                                <h4
                                    class="training-list-title1 training-list-title"
                                >{{ leariningMsg.name }}</h4>
                                <p class="training-list-time">
                                    {{
                                    leariningMsg.trainStartTime | formateData
                                    }}~{{
                                    leariningMsg.trainEndTime | formateData
                                    }}
                                    | 共{{ menuCount }}个目录
                                </p>
                            </div>
                            <p class="training-list-progress" v-if="courseCount">
                                <label>
                                    学习时长：{{
                                    totalLearnLength | formateTime
                                    }}小时 已学{{ totalStudyProcess }}%
                                </label>
                                <van-progress
                                    color="#1BB938"
                                    :percentage="totalStudyProcess"
                                    :show-pivot="false"
                                />
                            </p>
                        </div>
                    </li>
                    <div class="clear"></div>
                </ul>
            </div>

            <div class="training-content">
                <div class="courseDetail-content">
                    <div class="content-header">
                        <ul>
                            <li
                                class="headerspan"
                                @click="changecourseType(item)"
                                :class="
                                    changetype === item.id ? 'spanactive1' : ''
                                "
                                v-for="(item, index) in contentType"
                                :key="index"
                            >
                                <span>{{ item.name }}</span>
                            </li>
                        </ul>
                    </div>
                    <div v-if="changetype === '0'" class="content-info content-info-learning">
                        <p class="training_tips" v-html="description"></p>
                    </div>
                    <div v-if="changetype === '1'" class="content-info1">
                        <div class="training-list">
                            <div class="training-list-box" v-for="item in menuList" :key="item.id">
                                <p class="training-list-title">{{ item.stageName }}</p>
                                <div
                                    :class="
                                        totalStudyProcess && items.contentId == lastStudyCourseId
                                            ? 'traininglist traininglistbg'
                                            : 'traininglist'
                                    "
                                    v-for="items in item.children"
                                    :key="items.id"
                                    @click="items.type===1?goCourse(items):goExam(items)"
                                >
                                    <span
                                        class="trainingbg-border"
                                        :style="{background: items.type===1 ? '#3760FF' : '#FFA302'}"
                                    ></span>

                                    <h2
                                        :class="items.courseExpireStatus==2?'label':''"
                                        :style="{marginBottom: items.type===1 ? '0rem' : '0.2rem'}"
                                    >{{ items.courseStatus==8?'******':items.label }}</h2>
                                    <!--  -->
                                    <div
                                        class="label-tip"
                                        v-if="items.courseStatus==8 ||items.courseExpireStatus==2"
                                    >{{items.courseStatus==8?'很抱歉！此内容已被强制终止':'已过期不可查看'}}</div>

                                    <div class="trainingbg-tab" v-if="items.type===2">
                                        <span class="test">{{items.examType===1?'模拟考核':'正式考核'}}</span>
                                        <span
                                            :class="items.isPassed === 3 ? 'weizuoda' : 'passed'"
                                            v-if="items.isPassed!==2"
                                        >{{items.isPassed | isPassed}}</span>
                                    </div>
                                    <p
                                        class="training-time"
                                        :style="{marginTop: items.type===1 ? '0.5333rem' : '0.8533rem'}"
                                    >
                                        <span v-if="items.type===1">
                                            学习时长:
                                            <span>
                                                {{
                                                items.totalLearnLength | formateTime
                                                }}小时
                                            </span>
                                        </span>
                                        <span v-if="items.type===2">
                                            考试时长:
                                            <span>
                                                {{
                                                items.examLength
                                                }}分钟
                                            </span>
                                        </span>
                                        <span v-if="items.type===1" class="trainingbg-ico-center"></span>
                                        <label v-if="items.type===1">
                                            学习进度:{{
                                            items.studyProcess
                                            }}%
                                        </label>
                                    </p>
                                    <a
                                        class="training-path"
                                        v-if="
                                            totalStudyProcess && items.contentId == lastStudyCourseId && items.type===1
                                        "
                                    >
                                        <span class="training-path-ico">
                                            <img
                                                src="../../../assets/images/tarining/goon.png"
                                                width="12px"
                                                height="12px"
                                                alt
                                            />
                                        </span>继续学习
                                    </a>
                                    <a v-else>
                                        <svg-icon icon-class="left-arrow-icon" class-name="left-arrow-icon"></svg-icon>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="canToQuicklyStudy" class="detail-foot" :class="{ isMinzheng:theme === 'minzheng' }">
                <button v-if="totalStudyProcess" @click="quicklyStudy">继续学习</button>
                <button v-else @click="quicklyStudy">立即学习</button>
            </div>
        </div>
        <van-overlay :show="showOverlay" @click="showOverlay = false">
            <div class="wrapper" @click.stop>
                <div class="img-close">
                    <van-icon name="clear" class="close" @click="showOverlay = false" />
                </div>
                <img :src="previewUrl" class="overlay-img" />
                <div class="save-long">
                    <img src="../../../assets/images/learning/save-long@2x.png" alt />
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import cercertificateIsShowStatus from "../../../utils/certificateMixin";
export default {
    name: "learningDetails",
    data: () => {
        return {
            changetype: "1",
            contentType: [
                { name: "简介", id: "0" },
                { name: "课程表", id: "1" }
            ],
            showOverlay: false,
            menuList: [],
            description: "",
            leariningMsg: "",
            leariningid: "",
            timelength: "",
            totalLearnLength: "",
            totalStudyProcess: "",
            menuCount: "",
            isapp: false,
            courseCount: null, //课程数
            lastStudyCourseId:'',
            lastPlayItemId:'',
            theme:'',
            canToQuicklyStudy:false
        };
    },
    mixins: [cercertificateIsShowStatus],
    computed: {

    },
    filters: {
        isPassed(val) {
            if (val === 0) {
                return "未及格";
            } else if (val === 1) {
                return "已及格";
            } else if (val === 3) {
                return "未作答";
            }
        },
        formateTime: function(val) {
            return val ? (val / 3600).toFixed(2) : val;
        },
        formateData: function(val) {
            return val ? val.split(" ")[0] : "";
        }
    },
    created() {
        this.theme = sessionStorage.getItem('theme')
        var ua = navigator.userAgent.toLowerCase();
        var isWeixin = ua.indexOf("ezhouxing") != -1;
        if (!isWeixin) {
            this.isapp = true;
        } else {
            this.isapp = false;
        }
    },
    mounted() {
        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.back, false); //false阻止默认事件
        }
        this.leariningid = this.$route.query.id;
        this.findUserTrain();
        this.findBytips();
        this.getQuicklyStudyInfo();
        localStorage.setItem("faceidentify", 0);
        localStorage.setItem("firstfaceauth", 0);
        sessionStorage.setItem('imgOrPdf', 0)
    },
    destroyed() {
        window.removeEventListener("popstate", this.back, false); //false阻止默认事件
    },
    beforeRouteLeave(to, from, next) {
        this.showOverlay = false;
        next();
    },
    methods: {
        getQuicklyStudyInfo(){
            const taskType = 1
            this.$api.learning.quicklyStudy(this.leariningid,taskType).then( res => {
                if(res.code == 0 && res.data){
                    this.canToQuicklyStudy = true
                    this.lastStudyCourseId = res.data.courseId
                    this.lastPlayItemId = res.data.lastPlayItemId
                }
            })
        },
        quicklyStudy(){
            localStorage.setItem("faceidentify", 0);
            this.$router.push({
                path: "/scourse",
                query: {
                    courseId: this.lastStudyCourseId,
                    trainId: this.leariningid,
                    taskType:1,
                    backType:this.$route.query.backType
                }
            });
        },
        changecourseType(item) {
            this.changetype = item.id;
            if (item.id === "2") {
                // this.courseDetail(this.detailparam);
            }
        },
        back() {
           if(this.$route.query.backPath){
                this.$router.push({
                    path: this.$route.query.backPath,
                    query: {
                        goodsId:this.$route.query.goodsId,
                        goodsKind:this.$route.query.goodsKind,
                        distributionUserId:this.$route.query.distributionUserId,
                    }
                })
            }else{
                this.$router.push({ 
                    name: "learning",
                    query:{
                        backType:this.$route.query.backType
                    } 
                });
            }
            
            // this.$router.go(-1);
        },
        goCourse(item) {
            if (item.courseStatus == 8) {
                this.$notify({
                    type: "warning",
                    message: "很抱歉！此内容已被强制终止"
                });
                return;
            }
            localStorage.setItem("facecount", "0");
            if (this.leariningMsg.status === 1) {
                this.$notify({
                    type: "warning",
                    message: "课程还未开始，不能进入学习"
                });
            } else {
                localStorage.setItem("faceidentify", 0);
                this.$router.push({
                    path: "/scourse",
                    query: {
                        courseId: item.contentId,
                        trainId: item.trainId,
                        studyProcess: item.studyProcess,
                        taskType:1,
                        backType:this.$route.query.backType,
                        itemType:this.$route.query.type,
                        address:this.$route.query.address
                    }
                });
            }
        },
        goExam(items) {
        
            var trainId = items.trainId;
            var trainItemExamId = items.trainItemExamId;
            let contentId  = items.contentId;
            this.$router.push({
                path: "/examlistDetails",
                query: {
                    trainId,
                    trainItemExamId,
                    contentId,
                    type: '1',
                    backType:this.$route.query.backType,
                    itemType:this.$route.query.type,
                    address:this.$route.query.address
                }
            });

        },
        findUserTrain() {
            let params = {
                //列表
                trainId: this.leariningid
            };
            this.$api.training.findUserTrain({ params }).then(data => {
                this.menuCount = data.data.menuCount;
                this.courseCount = data.data.courseCount;
                this.totalStudyProcess = data.data.totalStudyProcess;
                this.totalLearnLength = data.data.totalLearnLength;
                let tempArr = [];
                let endData = [];
                let timeArr = [];
                let num = [];
                data.data.menuList.forEach(tiem => {
                    num.push(tiem.lastStudyTime);
                    if (tiem.lastStudyTime !== null) {
                        timeArr.push(tiem.lastStudyTime);
                    }
                });
                this.timelength = timeArr.sort(function(a, b) {
                    let formatA = a && new Date(a).getTime()
                    let formatB = b && new Date(b).getTime()
                    // console.log(formatA,formatB,'a,b===========')
                    return formatB - formatA;
                });
                // console.log(timeArr,this.timelength,'=============')
                data.data.menuList.forEach(item => {
                    tempArr.push(item.stageName);
                });
                let setName = [...new Set(tempArr)]; //.sort();
                setName.forEach((el, index) => {
                    let datalist = [];
                    data.data.menuList.forEach(items => {
                        if (el === items.stageName) {
                            datalist.push(items);
                        }
                    });
                    endData.push({
                        stageName: el,
                        id: index,
                        children: datalist
                    });
                });
                this.menuList = endData;
            });
        },
        findBytips() {
            //简介
            let params = {
                id: this.leariningid
            };
            this.$api.training.findById({ params }).then(data => {
                this.leariningMsg = data.data;
                this.description = data.data.description;
                if (this.leariningMsg.isConfigCert == 1) {
                    this.checkCertificate(
                        "businessId",
                        this.leariningid,
                        "",
                        "train"
                    );
                }
            });
        }
    }
};
</script> 
<style lang="less">
.training-Msgbox .van-tab__text {
    font-size: 18px;
}
.training-Msgbox .van-progress__portion {
    opacity: 1;
}
.training-Msgbox .van-progress {
    position: relative;
    height: 4px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
}
.van-overlay /deep/ .wrapper {
    width: 100%;
    margin-top: 30px;
    position: relative;
}
body /deep/.van-toast{
    background:rgba(0,0,0,.7) !important;
}
.content-info-learning{
    p{
        img{
            max-width: 100%;
            height:auto;
        }
    }
}
</style>
<style lang="less" scoped>
* {
    padding: 0;
    margin: 0;
}
.van-overlay {
    z-index: 92;
}
.van-overlay /deep/ .wrapper {
    width: 100%;
    margin-top: 30px;
    position: relative;
}
.van-overlay .wrapper .overlay-img {
    max-width: 345px;
    max-height: 380px;
    display: block;
    margin: 0 auto;
}
.van-overlay .wrapper .img-close {
    width: 345px;
    margin: 0 auto 10px auto;
    text-align: right;
}
.van-overlay .wrapper .close {
    font-size: 24px;
    color: #fff;
}
.van-overlay .wrapper .txt {
    width: 327px;
    line-height: 45px;
    background: linear-gradient(136deg, #227fff 0%, #316fff 100%);
    border-radius: 22px;
    text-align: center;
    line-height: 45px;
    color: #fff;
    font-size: 16px;
    margin: 32px auto 0;
}
.van-overlay .wrapper .save-long {
    margin: 20px auto;
    width: 230px;
    height: 49px;
}
.van-overlay .wrapper .save-long img {
    width: 100%;
    height: 100%;
}
.certifiBtn {
    position: absolute;
    top: 26px;
    right: 30px;
    z-index: 2;
}
.certifiBtn img {
    width: 48px;
    height: 48px;
}
.training-Msgbox {
    .training-top-bg {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 320px;
        filter: blur(40px);
        background-size: 100%;
    }
    .training-back {
        height: 100px;
        width: 100%;
        position: absolute;
        line-height: 100px;
        top: 0px;
        .arrow-icon{
            color: #fff;
            font-size: 40px;
            padding-left: 30px;
        }
    }
    .training-top-opctiy {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 320px;
        background: rgba(0, 0, 0, 0.3);
    }
    .training-content {
        position: relative;
        .courseDetail-content {
            .content-header {
                padding: 0;
                border-bottom: 1px solid #eaeaea;
                background: #ffffff;
            }
            .content-header ul {
                display: flex;
                align-items: center;
                .headerspan {
                    width: 136px;
                    margin: 37px 0 27px;
                    text-align: center;
                    position: relative;
                    span {
                        display: inline-block;
                        height: 100%;
                        position: relative;
                        font-size: 30px;
                        color: #666666;
                    }
                }
                .evaluation {
                    flex: 1;
                    margin-left: 56px;
                    p {
                        display: inline-block;
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #000000;
                        margin-right: 2px;
                        img {
                            vertical-align: middle;
                            width: 28px;
                            height: 28px;
                        }
                        &:last-child {
                            margin-left: 10px;
                            font-size: 28px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #000000;
                        }
                    }
                }
                .goevaluation {
                    width: 126px;
                    height: 52px;
                    border-radius: 26px;
                    border: 1px solid #405ff6;
                    font-size: 26px;
                    font-weight: 400;
                    color: #405ff6;
                    line-height: 52px;
                    text-align: center;
                    margin: 0 30px 0 24px;
                }
                .spanactive1 {
                    span {
                        font-size: 36px;
                        font-weight: 500;
                        color: #000000;
                        
                        
                    }
                }
            }
            .content-info {
                text-align: left;
                padding: 48px 32px;
                background: #fff;
                height: ~"calc(100vh - 14.2rem)";
                p {
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 56px;
                    word-break: break-all;
                    word-wrap: break-word;
                    white-space: normal;
                    img{
                        max-width: 100%;
                        height:auto;
                    }

                }
            }
            .content-catalog {
                margin-top: 30px;
                overflow: scroll;
                margin-bottom: 70px;
                text-align: left;
                .catalog-title {
                    position: relative;
                    .catalog-index {
                        width: 44px;
                        height: 44px;
                        line-height: 44px;
                        border-radius: 44px;
                        background: #fff1ed;
                        color: #e85a3a;
                        text-align: center;
                        font-size: 32px;
                        display: inline-block;
                        margin-right: 16px;
                    }
                    .catalog-futitle {
                        position: absolute;
                        top: -4px;
                    }
                    .catalog-hours {
                        position: absolute;
                        left: 60px;
                        bottom: -34px;
                        color: #737386;
                        font-size: 24px;
                    }
                }
            }
        }
        ul .headerspan {
            margin-top: 32px;
            margin-bottom: 32px;
            flex: 1;
            text-align: center;
            position: relative;
        }
        .training_tips {
            font-size: 28px;
            font-weight: 400;
            color: #666666;
            line-height: 56px;
            word-wrap: break-word;
        }
        .training-list {
            width: 100%;
            padding-bottom: 98px;

            .training-list-title {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 26px;
                font-weight: 400;
                color: #777777;
                line-height: 80px;
                padding-left: 30px;
                background: #f7f7f7;
            }
        }
        .training-list-box {
            .traininglistbg.traininglist {
                background: linear-gradient(
                    90deg,
                    rgba(255, 255, 255, 0.08) 0%,
                    rgba(255, 163, 2, 0.08) 100%
                ) !important;
            }
            .traininglist {
                padding-left: 30px;
                padding-top: 50px;
                position: relative;
                padding-bottom: 50px;
                border-bottom: 1px solid #eaeaea;
                background: #fff;
                .trainingbg-border {
                    display: inline-block;
                    vertical-align: middle;
                    width: 6px;
                    height: 32px;
                    line-height: 36px;
                    margin-right: 20px;
                    position: absolute;
                    top: 1.49rem;
                }
                h2 {
                    vertical-align: middle;
                    font-size: 34px;
                    color: #000000;
                    padding-left: 26px;
                    max-width: 540px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    display: inline-block;
                }
                .label {
                    max-width: 400px;
                }
                .label-tip {
                    display: inline-block;
                    font-size: 26px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ff5758;
                    line-height: 34px;
                    margin-left: 10px;
                }
                .training-time {
                    padding-left: 28px;
                    font-size: 26px;
                    font-weight: 400;
                    color: #999999;
                    line-height: 26px;
                    .trainingbg-ico-center {
                        height: 8px;
                        border-left: 1px solid #c1c1c1;
                        padding: 0px !important;
                    }
                    span,
                    label {
                        padding: 0 20px;
                    }
                    span:first-child {
                        padding: 0px;
                    }
                    .trainingbg-ico-center {
                        margin-left: 20px;
                    }
                }
                .training-path {
                    position: absolute;
                    top: 88px;
                    right: 30px;
                    font-size: 24px;
                    font-weight: 400;
                    color: #ffa302;
                    line-height: 24px;
                    .training-path-ico {
                        position: absolute;
                        left: -30px;
                        top: -2px;
                    }
                }
            }
        }
    }
    .training-title {
        height: 320px;
        position: relative;
        ul {
            position: absolute;
            top: 120px;
            li {
                height: 150px;
                margin-bottom: 80px;
                padding-left: 30px;
                a {
                    width: 200px;
                    height: 150px;
                    border-radius: 16px;
                    display: inline-block;
                    overflow: hidden;
                    img {
                        width: 200px;
                        height: 150px;
                    }
                }
                .right {
                    height: 100%;
                    height: 150px;
                    min-width: 446px;
                    padding-left: 20px;
                    display: inline-block;
                    position: absolute;
                    .justexam{
                        padding: 32px 0 32px;
                    }
                    .training-list-title {
                        font-size: 34px;
                        font-weight: 400;
                        color: #fff;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .training-list-title1 {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        max-width: 466px;
                    }
                    .training-list-time {
                        font-size: 24px;
                        font-weight: 400;
                        color: #fff;
                        margin-top: 5px;
                        margin-bottom: 15px;
                    }
                    .training-list-progress {
                        label {
                            font-size: 26px;
                            font-weight: 400;
                            color: #fff;
                            margin-bottom: 12px;
                            display: inline-block;
                        }
                    }
                }
            }
        }
    }
}
.trainingbg-tab {
    .test {
        box-sizing: border-box;
        padding: 3px 8px;
        width: 104px;
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        border: 1px solid #ff7501;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff7501;
        line-height: 30px;
        margin-left: 28px;
    }
    .passed {
        line-height: 32px;
        box-sizing: border-box;
        padding: 3px 8px;
        height: 32px;
        background: rgba(107, 232, 129, 0.28);
        border-radius: 4px;
        border: 1px solid #54b465;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #54b465;
        line-height: 30px;
        margin-left: 8px;
    }
    .weizuoda {
        line-height: 32px;
        box-sizing: border-box;
        padding: 3px 8px;
        height: 32px;
        background: rgba(153, 153, 153, 0.2);
        border-radius: 4px;
        border: 1px solid #999;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999;
        line-height: 30px;
        margin-left: 8px;
    }
}
.traininglist .left-arrow-icon {
    font-size: 24px;
    position: absolute;
    top: 50%;
    right: 30px;
    margin-top: -10px;
}
.detail-foot {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 98px;
    background: #ffffff;
    text-align: center;
    box-shadow: 0px 2px 0px 0px #EAEAEA;
    z-index: 100;
   button {
      width: 690px;
      height: 80px;
      text-align: center;
      line-height: 80px;
      background: linear-gradient(136deg, #407DF7 0%, #416DF6 100%);
      border-radius: 44px;
      border: 0;
      font-size: 32px;
      margin-top: 10px;
      color: #ffffff;
   }
   &.isMinzheng button {
       background: #CA4C2D;
   }
}
</style>
